"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellAnchorLocation = void 0;
/**
 * Cell Anchor Location for a PixiGameComponent using the Layout Manager.
 */
var CellAnchorLocation = exports.CellAnchorLocation = /*#__PURE__*/function (CellAnchorLocation) {
  CellAnchorLocation[CellAnchorLocation["Center"] = 0] = "Center";
  CellAnchorLocation[CellAnchorLocation["TopLeftCorner"] = 1] = "TopLeftCorner";
  CellAnchorLocation[CellAnchorLocation["TopRightCorner"] = 2] = "TopRightCorner";
  CellAnchorLocation[CellAnchorLocation["BottomLeftCorner"] = 3] = "BottomLeftCorner";
  CellAnchorLocation[CellAnchorLocation["BottomRightCorner"] = 4] = "BottomRightCorner";
  CellAnchorLocation[CellAnchorLocation["TopCenter"] = 5] = "TopCenter";
  return CellAnchorLocation;
}({});
//# sourceMappingURL=CellAnchorLocation.js.map